import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { Modal, ModalBody } from 'reactstrap';
import 'react-phone-input-2/lib/style.css'
import axios from 'axios';
import Swal from 'sweetalert2';
import ReactGA from 'react-ga';
import { useNavigate } from 'react-router-dom';
function TechnologyWorkDeveloper({ openModal, toggle, name, type, calculateModal }) {
    const [userData, setUserData] = useState({ name: '', email: '', experience: '', resources: 1, timePeriod: '' });
    const [defaultCountry, setDefaultCountry] = useState('us');
    const [errors, setErrors] = useState({});
    const [checkboxes, setCheckboxes] = useState({
        mobileApp: false,
        webApp: false,
    });
    const handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        setCheckboxes((prevState) => ({
            ...prevState,
            [id]: checked,
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData((prev) => ({
            ...prev, [name]: value
        }))
    }
    const handleClick = (value) => {
        if (value === 'increament') {
            setUserData((prev) => ({
                ...prev, resources: prev.resources + 1
            }))
        }
        else {
            if (userData.resources > 1) {
                setUserData((prev) => ({
                    ...prev, resources: prev.resources - 1
                }))
            }
        }
    }
    useEffect(() => {
        // Fetch the user's location to set the default country code
        axios.get('https://ipapi.co/json/')
            .then(response => {
                const countryCode = response.data.country_code.toLowerCase();
                setDefaultCountry(countryCode);
            })
            .catch(error => {
                console.error("Error fetching user location: ", error);
            });
    }, []);
    const [phoneNumber, setPhoneNumber] = useState({ dialingCode: '', number: '' });
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = (event) => {
        event.preventDefault();
        const isFormValid = validateForm();
        if (isFormValid) {
            ReactGA.event({
                category: 'Technology Form',
                action: `Submit Technology ${name} form `
            })
            const body = new FormData();
            let subject;
                        if (type) {
                const selectedApps = [];
                if (checkboxes.mobileApp) selectedApps.push('Mobile App');
                if (checkboxes.webApp) selectedApps.push('Web App');
                if (calculateModal) {
                    subject = { for: selectedApps.join(', ') }
                }
                else
                subject = { numberOfresources: userData.resources, timePeriod: userData.timePeriod, for: selectedApps.join(', ') }
            }

            else
                subject = { experience: userData.experience, numberOfresources: userData.resources, timePeriod: userData.timePeriod, technology: name }
            body.append('name', userData.name);
            body.append('email', userData.email);
            body.append('subject', JSON.stringify(subject));
            body.append('phone', `${phoneNumber.dialingCode}${phoneNumber.number}`);
            body.append('message', "from the technologies landing page check rate card");
            let url = 'https://noorisys.com/contact-submit/landing-form.php'
            // let url = 'https://nakbho.techtrial.life/patient/auth/send-email'
            let url2 = 'https://crm.thetechtrial.com/backend/api/inquiry/add'
     
            let subject1;
            if (type) {
                const selectedApps1 = [];
                if (checkboxes.mobileApp) selectedApps1.push('Mobile App');
                if (checkboxes.webApp) selectedApps1.push('Web App');
                if (calculateModal) {
                    subject1 =  selectedApps1.join(', ')
                }
                else
                subject1 = selectedApps1.join(', ')
            }

            const body2 = new FormData();
            body2.append('name', userData.name);
            body2.append('email', userData.email);
            body2.append('mobile', `+${phoneNumber.dialingCode}${phoneNumber.number}`);
            body2.append('message', "from the technologies landing page check rate card");
            body2.append('inquiry_source', '20');
            if(JSON.stringify(subject1) == undefined){
                body2.append('inquiry_for', '');
            } else {
                body2.append('inquiry_for', JSON.stringify(subject1));
            }
            body2.append('no_of_resources', userData.resources);
            body2.append('time_period', userData.timePeriod);
            if(name == undefined){
                body2.append('tech_stack', '');
            } else {
                body2.append('tech_stack', name);
            }
            body2.append('emp_experience', userData.experience);
            body2.forEach((value , key) => {console.log(value+" :"+key)})
            axios
                .post(url, body)
                .then((result) => {
                    // event.target.reset();
                    setUserData({ name: '', email: '', message: '', experience: '', resources: 1, timePeriod: '' })
                    setPhoneNumber({ dialingCode: defaultCountry, number: '' })
                    setCheckboxes({ mobileApp: false, webApp: false })
                    toggle();
                    // Swal.fire({ title: 'Thank you', icon: 'success', text: 'Thank you for your interest we will contact you shortly' })
                    navigate('/thankyou');
                },
                    (error) => {
                        Swal.fire({ title: 'Oops', icon: 'error', text: 'Something wrong happened please try again later' })
                    }
                );
            axios
                .post(url2, body2)
                .then((result) => {
                    // event.target.reset();
                    setUserData({ name: '', email: '', message: '', experience: '', resources: 1, timePeriod: '' })
                    setPhoneNumber({ dialingCode: defaultCountry, number: '' })
                    setCheckboxes({ mobileApp: false, webApp: false })
                    toggle();
                    // Swal.fire({ title: 'Thank you', icon: 'success', text: 'Thank you for your interest we will contact you shortly' })
                    navigate('/thankyou');
                },
                    (error) => {
                        Swal.fire({ title: 'Oops', icon: 'error', text: 'Something wrong happened please try again later' })
                    }
                );
        }
        else {
            setShowError(true);
            ReactGA.event({
                category: 'Technology Form',
                action: `Submit Technology ${name} form with fialed validation `
            })
        }
    }
    const validateForm = () => {
        const newErrors = {};
        const phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        if (userData.name.trim() === "") {
            newErrors.name = "Please provide your name";
        }

        // Validate Email
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
            newErrors.email = "Email Address Invalid";
        }

        if (userData.email.trim() === "") {
            newErrors.email = "Please provide email address";
        }
        if (phoneNumber.number === "") {
            newErrors.phone = "Please Provide phone number"
        }
        if (!type && userData.experience === "")
            newErrors.experience = "Please select experience"
        if (type && (!checkboxes.mobileApp && !checkboxes.webApp))
            newErrors.tech = "Please select any option "
        if (!calculateModal && userData.timePeriod === "") {
            newErrors.timePeriod = "Please select time period"
        }
        // if (userbody.phoneNumber.trim() !== '') {
        //     if (!phoneNumberRegex.test(userbody.phoneNumber)) {
        //         newErrors.phone = "Please provide valid phone number";
        //     }
        // }
        // if (userbody.phoneNumber.trim() === "") {
        //     newErrors.mobileNumber = "Phone NumberRequired");
        // }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    const modalContent = calculateModal
        ? 'Get Your Project Cost Now!'
        : `Hire a dedicated ${name ? `<b>${name}</b>` : ''} developer at a very competitive and reasonable cost.`;
    return (
        <div>
            <Modal isOpen={openModal} toggle={toggle} centered size='lg' className="custom-modal">
                {/* <ModalHeader toggle={toggle} className="custom-modal-header">

                </ModalHeader> */}
                <ModalBody className='form-block' >
                    <button type="button" className="custom-close-button" aria-label="Close" onClick={toggle}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h6 className='text-center pt20 pb20' dangerouslySetInnerHTML={{ __html: modalContent }}></h6>
                    {/* <div className='form-blocks-hom'> */}
                    <div className='form-body'>

                        <form className=''>
                            <div className='row'>
                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-name' className='form-label'>Full Name</label>
                                    <input placeholder="Full Name" className='input-ree' value={userData.name} type='text' name="name" id='technology-name' onChange={handleChange} />
                                    {showError && errors.name && < span style={{ color: 'red', fontSize: '14px' }}>{errors.name}</span>}
                                </div>
                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-email' className='form-label'> Email ID</label>
                                    <input placeholder='Enter your Email ID' className='input-ree' value={userData.email} type='email' name="email" id='technology-email' onChange={handleChange} />
                                    {showError && errors.email && <span style={{ color: 'red', fontSize: '14px' }}>{errors.email}</span>}
                                </div>
                                <div className='col-lg-6 col-12 fieldsets'>
                                    <label htmlFor='technology-email' className='form-label'>Phone Number</label>
                                    {/* <input placeholder='Mobile Number' className='input-ree' value={userData.email} type='email' name="email" id='technology-email' onChange={handleChange} /> */}
                                    <div style={{ marginBottom: '14px' }}>
                                        <PhoneInput
                                            country={defaultCountry}
                                            // value={this.state.phone}
                                            onChange={(value, data) => {
                                                const dialingCode = data?.dialCode;
                                                const phoneNo = value.substring(data.dialCode?.length);
                                                setPhoneNumber({ number: phoneNo, dialingCode: dialingCode })
                                            }}
                                            inputClass='phone-input'
                                            buttonStyle={{ borderRadius: '6px 0 0 6px' }}
                                        // containerClass='input-ree'

                                        />
                                    </div>
                                    {showError && errors.phone && <span style={{ color: 'red', marginTop: '10px', paddingBottom: '10px', fontSize: '14px' }}>{errors.phone}</span>}
                                </div>
                                {type === 'solutions' ? <div className='col-lg-6 col-12 fieldsets'>
                                    <label className='form-label'>Select a service</label>
                                    <div className=' d-flex justify-content-between align-items-center pt20'>
                                        <div className='d-flex align-items-center' style={{ gap: '8px' }}>
                                            <input type='checkbox' id='mobileApp' checked={checkboxes.mobileApp}
                                                onChange={handleCheckboxChange} className='' style={{ height: '20px', cursor: 'pointer', width: '20px' }} />
                                            <label htmlFor='mobile-app' className='form-label'>Mobile App</label>
                                        </div>
                                        <div className='d-flex align-items-center' style={{ gap: '8px' }}>
                                            <input type='checkbox' id='webApp' checked={checkboxes.webApp}
                                                onChange={handleCheckboxChange} className='' style={{ height: '20px', cursor: 'pointer', width: '20px' }} />
                                            <label htmlFor='web-app' className='form-label'>Web app</label>
                                        </div>
                                    </div>
                                    {showError && (!checkboxes.mobileApp && !checkboxes.webApp) && <span style={{ color: 'red', fontSize: '14px' }}>{errors.tech}</span>}
                                </div>
                                    : <div className='col-lg-6 col-12 fieldsets'>
                                        <label htmlFor='tech-exp' className='form-label'>Experience</label>
                                        <select className='m-mt20' name='experience' id='tech-exp' value={userData.experience} onChange={handleChange}>
                                            <option value={''}>Select Experience</option>
                                            <option value="Junior">Junior</option>
                                            <option value="senior">Senior</option>
                                        </select>
                                        {showError && (userData.experience === "") && <span style={{ color: 'red', fontSize: '14px' }}>{errors.experience}</span>}
                                    </div>}
                                {!calculateModal &&
                                    <div className='col-lg-6 col-12 fieldsets  '>
                                        <label htmlFor='technology-email ' className='form-label'>Number of Resource</label>
                                        <div className='text-center d-flex justify-content-center'>
                                            <button type='button' className='col-2' style={{ border: 'none', borderBottom: '2px solid #e6e6e6', width: '100%', height: '50px', borderRadius: '6px 0px 0 6px', fontSize: '30px' }} disabled={userData.resources === 1 ? true : false} onClick={(e) => handleClick('decreament')}>-</button>
                                            <input type='text' className='text-center col-8' value={userData.resources} name='resources' disabled />
                                            <button type='button' className='col-2' style={{ border: 'none', borderBottom: '2px solid #e6e6e6', width: '100%', height: '50px', borderRadius: '0 6px 6px 0' }} onClick={(e) => handleClick('increament')}>+</button>
                                        </div>
                                    </div>
                                }
                                {!calculateModal &&
                                    <div className='col-lg-6 col-12 fieldsets'>
                                        <label htmlFor='technology-email' className='form-label'>Time Period</label>
                                        <select className='col-12' value={userData.timePeriod} name='timePeriod' onChange={handleChange}>
                                            <option value="" disabled>Select time period</option>
                                            <option value="lessthanamonth">Less than a month</option>
                                            <option value="1-3months">1-3 months</option>
                                            <option value="3-6months"> 3-6 months</option>
                                            <option value="morethan6months">More than 6 months</option>
                                        </select>
                                        {showError && (userData.timePeriod === "") && <span style={{ color: 'red', fontSize: '14px' }}>{errors.timePeriod}</span>}
                                    </div>
                                }
                                <div className='col-lg-12 pt30 col-12 d-flex justify-content-end align-items-center'>
                                    <button className="ree-btn ree-btn-grdt1 w-100" onClick={handleSubmit} id='noorisys-quote'>
                                        {type ? "Next" : "Send an Enquiry"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </ModalBody >
            </Modal >
        </div >
    )
}

export default TechnologyWorkDeveloper


